import { render, staticRenderFns } from "./BeneficiariosReportList.vue?vue&type=template&id=bac06e00"
import script from "./BeneficiariosReportList.vue?vue&type=script&lang=js"
export * from "./BeneficiariosReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports